import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chipDefaultVariants = {
  "palette": "subtle",
  "size": "md",
  "isRounded": true
}
const chipCompoundVariants = []

const chipSlotNames = [
  [
    "root",
    "Chip__root"
  ],
  [
    "icon",
    "Chip__icon"
  ],
  [
    "label",
    "Chip__label"
  ],
  [
    "dismissButton",
    "Chip__dismissButton"
  ]
]
const chipSlotFns = /* @__PURE__ */ chipSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chipDefaultVariants, getSlotCompoundVariant(chipCompoundVariants, slotName))])

const chipFn = memo((props = {}) => {
  return Object.fromEntries(chipSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chipVariantKeys = [
  "palette",
  "isRounded",
  "size",
  "isError",
  "isMultiline"
]
const getVariantProps = (variants) => ({ ...chipDefaultVariants, ...compact(variants) })

export const chip = /* @__PURE__ */ Object.assign(chipFn, {
  __recipe__: false,
  __name__: 'chip',
  raw: (props) => props,
  variantKeys: chipVariantKeys,
  variantMap: {
  "palette": [
    "default",
    "subtle"
  ],
  "isRounded": [
    "true"
  ],
  "size": [
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "isError": [
    "true"
  ],
  "isMultiline": [
    "true"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chipVariantKeys)
  },
  getVariantProps
})